// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"918":"2af34833","927":"d0289805","4518":"d0289805","6403":"d0289805","7068":"fd76e516"}[chunkId] + ".chunk.css";
};